import { computed, defineComponent, inject, PropType } from "vue";
import { mapActions } from "pinia";

import { Product } from "@/models/Product";
import BuyButton from "@/components/BuyButton.vue";
import FormControlQuantity from "@/components/FormControlQuantity.vue";
import { useCart } from "@/store/useCart";
import { CartRow } from "@/models/Cart";
import FormControlSelect from "@/components/FormControlSelect.vue";
import { Option } from "@/models/Option";
import QuantityBreaks from "@/components/QuantityBreaks/QuantityBreaks.vue";

export default defineComponent({
  components: {
    FormControlSelect,
    FormControlQuantity,
    BuyButton,
    QuantityBreaks
  },
  data() {
    return { 
      quantity: 1,
      showPricesAsB2b:false,
      hidePrices:false,
      isLoading: false,
      displaySuccess:false, 
    };
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    categoryurl: {
      type: String,
      required: true,
    },
    categoryname: {
      type: String,
      required: true,
    }
  },
  computed: {
    variants() {
      if (this.product && this.product.variants) {
        return this.product.variants.map((x) => {
          const option: Option = {
            name: x.name,
            value: x.url,
            selected: x.isPrimary,
          };
          return option;
        });
      }
      return [];
    },
    currentDisplayedPrice() {
      const matchingQtyBreak = this.findQuantityBreakForCurrentQuantity();

      if (matchingQtyBreak?.value != null) {
        if (this.product.unitType.toLowerCase() == 'kg')
        {
          return this.showPricesAsB2b
          ? `${matchingQtyBreak.value}/${this.displayedWeight}`
          : `${matchingQtyBreak.valueIncVat}/${this.displayedWeight}`
        }
        return this.showPricesAsB2b
          ? `${matchingQtyBreak.value}/${this.product.unitType.toLowerCase()}`
          : `${matchingQtyBreak.valueIncVat}/${this.product.unitType.toLowerCase()}`
      } 
      return null
    },
    displayedWeight() {
      if(this.product.unitType == 'kg')
      {
        return 'ton';
      }
      return this.product.unitType.toLowerCase();
    }
  },
  mounted() {
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
    this.hidePrices = inject<boolean>("hide-prices", false);
  },
  methods: {
    async onBuyButtonClick() {
      if (this.product && this.product.sku && this.canCombineProducts()) {

        this.isLoading = true
        await this.addToCart(this.product.sku, this.quantity, false);
        this.isLoading = false

        const e = document.getElementById('cart')
        const miniCart = document.getElementById('miniCartWrap')
        this.displaySuccess = true
        e?.classList.add('shake')
        miniCart?.classList.add('toggle')

        setTimeout(() => {
          e?.classList.remove('shake')
          miniCart?.classList.remove('toggle')
          this.displaySuccess = false;
        }, 2000);
      }
    },
    onSelectVariant(value) {
      location.assign(value);
    },
    canCombineProducts(): boolean {
      const cart = useCart();
      const items = computed(() => {
        return cart.items as CartRow[];
      });

      const bulk = "kg";
      const pall = "Pall";
      const st = "Styck";
      
      const currentProductUnitType = this.product.unitType;
      for (const item of items.value) {
        const cartItemUnitType = item.unitType;
        const cartItemProductType = item.productType;
        if (currentProductUnitType === bulk && cartItemUnitType !== bulk && cartItemProductType === "Standard") {
          return false;
        }
        if ((currentProductUnitType === pall || currentProductUnitType === st) && cartItemUnitType === bulk && cartItemProductType === "Standard") {
          return false;
        }
      }
      return true;
    },
    findQuantityBreakForCurrentQuantity() {
      if (Array.isArray(this.product.quantityBreaks)) {
        let matchingQtyBreak = null;
        let closestLowerQtyBreak = { qtyBreak: -1, value: null, valueIncVat: null, currencyCode: null };
    
        for (const quantityBreak of this.product.quantityBreaks) {
          if (quantityBreak.qtyBreak === this.quantity) {
            matchingQtyBreak = quantityBreak;
            break;
          }
    
          if (quantityBreak.qtyBreak < this.quantity) {
            if (quantityBreak.qtyBreak > closestLowerQtyBreak.qtyBreak) {
              closestLowerQtyBreak = quantityBreak;
            }
          }
        }
    
        return matchingQtyBreak || closestLowerQtyBreak;
      }
    
      return null;
    },
    ...mapActions(useCart, ["addToCart"])
  }
});
